import { render, staticRenderFns } from "./TeacherCard.vue?vue&type=template&id=86ba054c&scoped=true&"
import script from "./TeacherCard.vue?vue&type=script&lang=js&"
export * from "./TeacherCard.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCard.vue?vue&type=style&index=0&id=86ba054c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ba054c",
  null
  
)

export default component.exports